import {
  ACCOUNT_TYPE_IRA_ROTH,
  ACCOUNT_TYPE_IRA_TRADITIONAL,
  ACCOUNT_TYPE_IRA_SIMPLE,
  ACCOUNT_TYPE_IRA_SEP,
  ACCOUNT_TYPE_UTMA_CUSTODIAN,
  ACCOUNT_TYPE_UTMA_TRUSTEE,
  ACCOUNT_TYPE_CORPORATE_LLC,
  ACCOUNT_TYPE_CORPORATE_CORPORATE,
  ACCOUNT_TYPE_CORPORATE_SOLE_PROPRIETORSHIP,
  ACCOUNT_TYPE_CORPORATE_PARTNERSHIP,
  ACCOUNT_TYPE_CORPORATE_TRUST,
  ACCOUNT_TYPE_JOINT_TENANTS_COMMON,
} from '../../constants/accountTypes';

export const userRequestQueryParam = (
  applicationType,
  accountType,
  registrationFlowType,
  brokerCode,
  logonUid,
  username,
  userUid = '',
) => {
  switch (accountType) {
    case ACCOUNT_TYPE_IRA_ROTH:
    case ACCOUNT_TYPE_IRA_TRADITIONAL:
    case ACCOUNT_TYPE_IRA_SIMPLE:
    case ACCOUNT_TYPE_IRA_SEP:
      if (userUid) {
        return {
          applicationType,
          iraAccountType: accountType,
          registrationFlowType,
          brokerCode,
          logonUid,
          username,
          userUid,
        };
      }
      return {
        applicationType,
        iraAccountType: accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      };
    case ACCOUNT_TYPE_UTMA_CUSTODIAN:
    case ACCOUNT_TYPE_UTMA_TRUSTEE:
      if (userUid) {
        return {
          applicationType,
          utmaAccountType: accountType,
          registrationFlowType,
          brokerCode,
          logonUid,
          username,
          userUid,
        };
      }
      return {
        applicationType,
        utmaAccountType: accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      };

    case ACCOUNT_TYPE_CORPORATE_LLC:
    case ACCOUNT_TYPE_CORPORATE_CORPORATE:
    case ACCOUNT_TYPE_CORPORATE_SOLE_PROPRIETORSHIP:
    case ACCOUNT_TYPE_CORPORATE_PARTNERSHIP:
    case ACCOUNT_TYPE_CORPORATE_TRUST:
      if (userUid) {
        return {
          applicationType,
          corporateAccountType: accountType,
          registrationFlowType,
          brokerCode,
          logonUid,
          username,
          userUid,
        };
      }
      return {
        applicationType,
        corporateAccountType: accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      };

    case ACCOUNT_TYPE_JOINT_TENANTS_COMMON:
      if (userUid) {
        return {
          applicationType,
          jointTenantsAccountType: accountType,
          registrationFlowType,
          brokerCode,
          logonUid,
          username,
          userUid,
        };
      }
      return {
        applicationType,
        jointTenantsAccountType: accountType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      };

    default:
      if (userUid) {
        return {
          applicationType,
          registrationFlowType,
          brokerCode,
          logonUid,
          username,
          userUid,
        };
      }
      return {
        applicationType,
        registrationFlowType,
        brokerCode,
        logonUid,
        username,
      };
  }
};
